import React from 'react';
import { actionTypes, formFieldTypes, documentStatuses, documentBpActions as bpActions, docTypes, formModes } from '../../constants';
import i18next from "../../i18n";
import { renderAttachments, renderFormHeader, renderMainContract, renderMainFile, renderAdditionalCounterparties } from '../document/DocumentHelpers';
export const statuses = Object.assign(documentStatuses, {
    rejectedCounterparty: "Rejected Counterparty", //Відхилено контрагентом
    refinement: "Refinement", //На доопрацюванні
    acquaintanceCounterparty: "Acquaintance Counterparty", //На ознайомленні контрагентом
    signing: "Signing", //На підписанні
    consideration: "Consideration", //На розгляді
    signed: "Signed", //Підписано
    signedCounterparty: "Signed Counterparty", //Підписано контрагентом
    canceled: "Canceled", //Скасовано
    processingCofco: "Processing Cofco", //На обробці COFCO,
    agreementCofco: "Agreement Cofco" //На узгодженні COFCO
});
export const contractTypes = {
    Other: "Other",
    TEO: "TEO",
    Storage: "Storage",
    Transshipment: "Transshipment",
    Supply: "Supply",
    Sales: "Sales",
    Additional: "Additional", // Додаткова угода
    Protocol: "Protocol" // Протокол розбіжностей
}
export const settings = {
    statuses: statuses,
    actions: [
        {
            title: i18next.t("sendTo"),
            btnClass: "btn-secondary",
            action: bpActions.approve,
            type: actionTypes.save,
            statuses: [statuses.project, statuses.signingCounterparty, statuses.additionalSigningCounterparty, statuses.refinementCounterparty, statuses.preparation, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("signOrElectronicSeal"),
            btnClass: "btn-primary",
            type: actionTypes.sign,
            statuses: [statuses.project, statuses.signedCounterparty, statuses.signingCounterparty, statuses.additionalSigningCounterparty, statuses.refinementCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("forAdditionalSigning"),
            btnClass: "btn-secondary",
            action: bpActions.additionalSigning,
            type: actionTypes.additionalSign,
            statuses: [statuses.project, statuses.signingCounterparty, statuses.signedCounterparty, statuses.refinementCounterparty, statuses.signingCounterpartyMD]
        },
        {
            title: i18next.t("forRevision"),
            btnClass: "btn-secondary",
            action: bpActions.refinement,
            type: actionTypes.save,
            statuses: [statuses.signingCounterparty, statuses.signingCounterpartyMD]
        },
        {
            title: i18next.t("reject"),
            btnClass: "btn-secondary",
            action: bpActions.reject,
            type: actionTypes.save,
            statuses: [statuses.signingCounterparty, statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("edit"),
            btnClass: "btn-secondary",
            type: actionTypes.edit,
            statuses: [statuses.project, statuses.signedCounterparty, statuses.refinementCounterparty]
        },
        {
            title: i18next.t("cancel"),
            btnClass: "btn-secondary",
            action: bpActions.annul,
            type: actionTypes.annul,
            statuses: [documentStatuses.project, documentStatuses.refinementCounterparty, documentStatuses.signedCounterparty, documentStatuses.preparationCounterparty],
            modes: [formModes.read]
        }
    ]
}
export function renderinformation() {
    const { prop_sx_docKind, prop_sx_documentType } = this.state;
    return (
        <div key="informationTab">
            <div className="doc-form-block" key="informationTabBlock">
                {renderFormHeader.bind(this)()}
                {renderAdditionalCounterparties.bind(this)()}
                <div className="form-block large-form doc-form doc-form__creat">
                    <div className="form-content">
                        <div className="row">
                            {this.buildFormSection("mainForm")}
                            {docTypes.contract === prop_sx_documentType ? ((prop_sx_docKind === contractTypes.Additional || prop_sx_docKind === contractTypes.Protocol) ? renderMainContract.bind(this)({ "DocType": docTypes.contract, "Status": [statuses.valid] }) : "") : renderMainContract.bind(this)({ "DocType": docTypes.contract, "Status": [statuses.valid] })}
                            {renderAttachments.bind(this)()}
                            <div className="col-lg-12">
                                <div className="required-label"><label className="required"></label>{i18next.t("requiredFields")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderMainFile.bind(this)()}
        </div>
    )
}
export function checkInputPage(checkAll = true) {
    const { prop_sx_regNumber, prop_sx_regDate, prop_sx_docKind, mainDocuments, associations, assoc_sxcfc_contractAssoc_added } = this.state;
    let check = checkAll ?
        !!(prop_sx_regNumber && prop_sx_docKind && prop_sx_regDate
            && mainDocuments?.length > 0
            && ((prop_sx_docKind !== contractTypes.Additional && prop_sx_docKind !== contractTypes.Protocol) || associations?.contractAssoc?.length > 0 || assoc_sxcfc_contractAssoc_added))
        :
        !!(prop_sx_regDate && prop_sx_regNumber && prop_sx_docKind) && mainDocuments?.length > 0;
    return check;
}
export function buildFormItem(item) {
    const { prop_sx_docKind } = this.state;
    if (['sx_docKind', 'sx_docSubKind', 'sxcfc_termsDelivery'].includes(item.Name.replace('prop_', ''))) {
        for (let i = 0; i < item?.Values?.Data?.length; ++i)
            item.Values.Data[i].Hidden = !item.Values.Data[i].PortalEnabled;
        let showItems = item.Values.Data.filter(e => e.Hidden === false);
        if (showItems?.filter(e => e.Value === item.Value).length === 0) {
            item.Value = this.state[item.Name] = showItems.length > 0 ? showItems[0].Value : "";
        }
    }
    if (item.Name === "prop_sx_docSubKind" && prop_sx_docKind !== contractTypes.Additional) {
        item.Type = formFieldTypes.empty;
    }
    return item;
}